import { observer } from 'mobx-react-lite';
import { AppName, Env } from 'src/core/Environment';
import { TaskRepresentation } from 'src/generated-api-client';
import { AgentTaskListItem } from 'src/pages/TasksPage/components/AgentTaskListItem';
import { BOTaskListItem } from 'src/pages/TasksPage/components/BOTaskListItem';

export type TaskListItemProps = {
    item: TaskRepresentation;
};

export const TaskListItem = observer(({ item }: TaskListItemProps) => {
    if (Env.appName === AppName.AGENT_PORTAL) {
        return <AgentTaskListItem item={item} />;
    }

    return <BOTaskListItem item={item} />;
});
